import { gql, TypedDocumentNode } from "@apollo/client";

import { QuerySearchRevisionsArgs, SearchRevisionsOutput } from "types/generated";

export const SEARCH_SPACELIFT_VCS_REPO_REVISIONS: TypedDocumentNode<
  { searchRevisions: SearchRevisionsOutput },
  QuerySearchRevisionsArgs
> = gql`
  query SearchSpaceliftVcsRepoRevisions($repoID: ID!, $input: SearchInput!) {
    searchRevisions(repoID: $repoID, input: $input) {
      edges {
        cursor
        node {
          id
          sha
          message
          description
          authorName
          authorEmail
          createdAt
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`;
